import Helper from "../d3-common"
import "lodash"

const d3 = Object.assign(
    {},
    require("d3-array"),
    require("d3-selection"),
    require("d3-transition"),
    require("d3-ease"),
    require("d3-scale")
)

export function drawContent() {
    // For nested functions
    const dimensions = this.dimensions
    const scaleR = this.scaleR
    const scaleX = this.scaleX
    const cameraAccessor = this.cameraAccessor
    const selectedDimension = this.selectedDimension
    const cObj = this

    // overall view
    const sumView = d3.rollup(this.dataset, v => v.length, this.cameraAccessor)
    this.sumView = Array.from(sumView)

    // Information about cameras
    const cameras = d3.group(
        this.dataset,
        d => _.split(_.lowerCase(d.exif.make), " ")[0]
    )

    // Rollup cameras
    const rollup = d3.rollup(
        this.dataset,
        v => v.length,
        d => _.split(_.lowerCase(d.exif.make), " ")[0]
    )

    // Order Cameras
    const cameraOrder = []
    rollup.forEach((value, key) => {
        let pair = {}
        ;(pair.brand = key), (pair.amount = value)
        cameraOrder.push(pair)
    })

    const cameraFinal = cameraOrder
        .sort((a, b) => (a.amount < b.amount ? 1 : -1))
        .filter(str => str.brand.length > 2)

    // re-calculate height of container
    const calculatedHeight =
        (cameraFinal.length + 2) * this.dimensions.lineHeight
    this.wrapper.attr("height", calculatedHeight)
    d3.select("#clipRect").attr("height", calculatedHeight)
    d3.select("#clipWideRect").attr("height", calculatedHeight)

    cameraFinal.forEach((obj, index) => {
        const y =
            (index + 1) * this.dimensions.lineHeight +
            this.dimensions.margin.top

        // Each brand has own container
        let brand = this.wrapper.append("g").attr("id", obj.brand)

        brand
            .append("line")
            .attr("x1", this.dimensions.margin.left)
            .attr("y1", y)
            .attr("x2", this.dimensions.width - this.dimensions.margin.right)
            .attr("y2", y)
            .attr("class", "grid-line")
            .attr("stroke", "#ccc")
            .attr("stroke-width", 0.5)

        brand
            .append("text")
            .attr("x", 20)
            .attr("y", y + 5)
            .attr("class", "brand")
            .attr("data-id", obj.brand)
            .text(_.upperFirst(obj.brand))
        // .attr("cursor", "pointer")
        // .on("click", toggleBrand)

        // brand
        //     .append("svg:image")
        //     .attr("xlink:href", "/assets/images/simple-right.svg")
        //     .attr("x", 0)
        //     .attr("y", y - 10)
        //     .attr("height", 16)
        //     .attr("width", 16)
        //     .attr("class", "arrow")
        //     .attr("data-id", obj.brand)
        //     .attr("fill", "#31eae1")
        // .attr("cursor", "pointer")
        // .on("click", toggleBrand)

        // Rollup each brand and convert tp array
        const rolledSet = d3.rollup(
            cameras.get(obj.brand),
            v => v.length,
            this.cameraAccessor
        )

        const camerasSum = []
        rolledSet.forEach((value, key) => {
            let pair = {}
            let text
            // Revert exposure time to 1/x format
            if (key) {
                text = key.toString()
                // console.log(value)
                if (this.selectedDimension === "exposure_time") {
                    const dimValue = Number(text)
                    if (dimValue < 1000) {
                        text = "1/" + Math.round(1000 / dimValue) + " s"
                    } else {
                        text = Math.round(dimValue / 1000) + " s"
                    }
                }
            } else {
                text = "not provided"
            }
            ;(pair[this.selectedDimension] = key),
            (pair.amount = value),
            (pair.text = text)
            camerasSum.push(pair)
        })
        // Keep certain values in local storage
        let locStorage = JSON.parse(localStorage.getItem("d3_camera"))
        locStorage[obj.brand] = {}
        locStorage[obj.brand].index = index
        locStorage[obj.brand].brandName = obj.brand
        locStorage[obj.brand].brandData = camerasSum

        window.localStorage.setItem("d3_camera", JSON.stringify(locStorage))

        createBrandDots(camerasSum, obj.brand, index)
    })

    function toggleBrand(datum) {
        const node = d3.select(`#${this.dataset.id}`)
        const brand = this.dataset.id
        const state = node.node().dataset.state

        if (state === "selected") {
            node.attr("data-state", "")
            revertBrand(this)
        } else {
            node.attr("data-state", "selected")
            exposeBrand(this)
        }
    }

    function exposeBrand(node) {
        const brand = node.dataset.id
        const y = node.getAttribute("y")
        // Hide all others
        wrapper
            .selectAll("g")
            .filter(`:not(#${brand})`)
            .filter(`:not(#brush)`)
            .transition()
            .duration(800)
            .style("opacity", 0)
            .attr("transform", `translate(-5000, 0)`)

        // Move Container to the top
        wrapper
            .selectAll("g")
            .filter(`#${brand}`)
            .transition()
            .duration(800)
            .ease(d3.easeCubicInOut)
            .attr(
                "transform",
                `translate(0, ${-1 * y +
                    dimensions.margin.top +
                    dimensions.lineHeight +
                    5})`
            )
            .select("image")
            .style("opacity", 0.2)
            .end()
            .then(() => {
                createCameraModels(brand)
            })
    }

    function revertBrand(node) {
        // re-generate brand dots
        const brand = node.dataset.id
        let locStorage = JSON.parse(localStorage.getItem("d3_camera"))
        const index = locStorage[brand].index
        const brandData = locStorage[brand].brandData

        const y = node.getAttribute("y")

        // Hide all others
        wrapper
            .selectAll("g")
            .transition()
            .duration(500)
            .attr("transform", `translate(0, 0)`)
            // .delay(500)
            .transition()
            .duration(800)
            .style("opacity", 1)
            .select("image")
            .style("opacity", 1)

        // removeCameraModels(brand)
        d3.select("#model")
            .transition()
            .duration(500)
            .style("opacity", 0)
            .remove()
            .end()
            .then(() => {
                createBrandDots(brandData, brand, index)
            })
    }

    function createBrandDots(brandData, brandName, index) {
        const brand = d3.select(`#${brandName}`)

        brand
            .selectAll("circle")
            .data(brandData)
            .enter()
            .append("circle")
            .attr(
                "cy",
                (index + 1) * dimensions.lineHeight + dimensions.margin.top
            )
            .attr("cx", 0)
            .on("mouseenter", mouseOver)
            .on("mouseleave", mouseOut)
            .on("click", (d, i, node) => {
                if (d[selectedDimension] > 0) {
                    cObj.selectedBrand = brandName
                    tooltip(d, i, node, cObj)
                }
            })
            .transition()
            .duration(d => {
                if (d[selectedDimension] > 0) {
                    return 1.5 * scaleX(d[selectedDimension])
                } else {
                    return dimensions.width
                }
            })
            .ease(d3.easeCubicInOut)
            .attr("cx", (d, i) => {
                if (d[selectedDimension] > 0) {
                    return scaleX(d[selectedDimension])
                } else {
                    return dimensions.width - dimensions.margin.right / 2
                }
            })
            .attr("r", d => scaleR(d.amount))
            .attr("fill", d => {
                if (d[selectedDimension] > 0) {
                    return "#31eae1"
                } else {
                    return "grey"
                }
            })
            .attr("stroke", "black")
            .attr("stroke-width", 1)
            .attr("opacity", 0.3)
            .attr("id", d => d[selectedDimension])
            .attr("class", d => {
                if (d[selectedDimension] > 0) {
                    return "dot"
                }
            })
    }

    function mouseOver(d) {
        if (d[selectedDimension] > 0) {
            d3.select(this)
                .attr("opacity", 0.7)
                .attr("r", d => {
                    if (scaleR(d.amount) < 15) {
                        return 15
                    } else {
                        return scaleR(d.amount)
                    }
                })
        }
    }
    function mouseOut(d) {
        d3.select(this)
            .attr("opacity", 0.3)
            .attr("r", d => scaleR(d.amount))
    }

    function tooltip(datum, i, node, obj) {
        const tooltip = d3.select("#tooltip")

        const w = tooltip.node().offsetWidth
        const h = tooltip.node().offsetHeight

        const circle = node[i]
        const cx = +circle.getAttribute("cx")
        const cy = +circle.getAttribute("cy")
        const ctm = circle.getCTM()
        const coords = Helper.getScreenCoords(cx, cy, ctm)

        const x = coords.x - w / 2 // weird offset due to 45 angle
        const y = coords.y - h - 20

        tooltip
            .interrupt()
            .style("transform", `translate(${x}px, ${y}px)`)
            .transition()
            .style("opacity", 1)
            .attr("data-id", datum.id)

        tooltip.select("#dimension").text(`${obj.selectedDimensionText}`)
        tooltip.select("#dimensionValue").text(`${datum.text}`)
        tooltip.select("#amount").text(`${datum.amount}`)

        obj.selectedValue = datum.text
    }

    function createCameraModels(brand) {
        console.log("Create models of " + brand)
        // Calculate position
        const model = cameras.get(brand)
        const camerasmodel = d3.group(model, d => _.lowerCase(d.exif.model))

        const modelArray = []
        camerasmodel.forEach((value, key) => {
            let pair = {}
            ;(pair.model = key), (pair.data = value)
            modelArray.push(pair)
        })

        const modelFinal = modelArray.sort((a, b) =>
            a.model > b.model ? 1 : -1
        )

        const modelNode = obj.wrapper.append("g").attr("id", "model")
        // Build Model list

        modelFinal.forEach((obj, index) => {
            const y =
                (index + 1) * dimensions.lineHeightModel +
                dimensions.margin.top +
                dimensions.lineHeightModel +
                dimensions.lineHeight

            // Each brand has own container
            modelNode
                .append("line")
                .attr("x1", dimensions.margin.left)
                .attr("y1", y)
                .attr("x2", dimensions.width - dimensions.margin.right)
                .attr("y2", y)
                .attr("class", "grid-line")
                .attr("stroke", "#ccc")
                .attr("stroke-width", 0.5)
                .attr("opacity", 0)
                .transition()
                .duration(750)
                .attr("opacity", 1)

            modelNode
                .append("text")
                .attr("x", 20)
                .attr("y", y + 5)
                .attr("class", "model")
                .attr("data-id", obj.model)
                .text(_.upperFirst(obj.model))
                .attr("opacity", 0)
                .transition()
                .duration(750)
                .attr("opacity", 1)

            // Rollup each brand and convert to array
            const rolledModel = d3.rollup(
                camerasmodel.get(obj.model),
                v => v.length,
                cameraAccessor
            )

            const ModelSum = []
            rolledModel.forEach((value, key) => {
                let pair = {}
                let text
                if (key) {
                    text = key.toString()
                    if (selectedDimension === "exposure_time") {
                        const dimValue = Number(text)
                        if (dimValue < 1000) {
                            text = "1/" + Math.round(1000 / dimValue) + " s"
                        } else {
                            text = Math.round(dimValue / 1000) + " s"
                        }
                    }
                } else {
                    text = "not provided"
                }

                ;(pair[selectedDimension] = key),
                (pair.amount = value),
                (pair.text = text)
                ModelSum.push(pair)
            })

            // Increase size of wrapper
            // const newHeight = modelFinal.length* this.dimensions.lineHeightModel + this.dimensions.margin.top +
            // this.dimensions.lineHeight
            // wrapper.attr("height", newHeight)

            // Move dots

            let r
            const Modellength = modelFinal.length

            d3.select(`#${brand}`)
                .selectAll("circle")
                .datum((d, i, n) => {
                    r = +d3.select(n[i]).attr("r")
                })
                .transition()
                .duration(1500)
                .attr("r", (r / Modellength) * (Modellength - index))
                .remove()

            // Create the Dots
            modelNode
                .data(ModelSum)
                .append("circle")
                // .on("mouseenter", tooltip)
                .on("mouseenter", (d, i, node) => {
                    tooltip(d, i, node, cObj)
                })
                .on("mouseleave", this.hideTooltip)
                .attr("cx", (d, i) => {
                    if (d[selectedDimension] > 0) {
                        return scaleX(d[selectedDimension])
                    } else {
                        return dimensions.width - dimensions.margin.right / 2
                    }
                })
                .attr(
                    "cy",
                    dimensions.margin.top +
                        dimensions.lineHeight +
                        dimensions.lineHeightModel
                )
                .transition()
                .duration(2000)
                .attr(
                    "cy",
                    (index + 2) * dimensions.lineHeightModel +
                        dimensions.margin.top +
                        dimensions.lineHeight
                )
                .attr("r", d => scaleR(d.amount))
                .attr("fill", d => {
                    if (d[selectedDimension] > 0) {
                        return "#31eae1"
                    } else {
                        return "grey"
                    }
                })
                .attr("stroke", "black")
                .attr("stroke-width", 1)
                .attr("opacity", 0.3)
                .attr("id", d => d[selectedDimension])
                .attr("class", (d, i) => {
                    return "dot"
                })
        })
    }
}

export function hideToolTip() {
    const toolTipTransition = d3
        .transition()
        .duration(250)
        .ease(d3.easeCubicOut)

    d3.select("#tooltip")
        .style("opacity", 1)
        .transition(toolTipTransition)
        .duration(500)
        .delay(200)
        .style("opacity", 0)
        .transition()
        .delay(200)
        .transition()
        .style("transform", "translate(-2000px, -2000px)")
}

export function redraw(zoomScale) {
    const locStorage = JSON.parse(localStorage.getItem("d3_camera"))
    let count = 0

    for (let property in locStorage) {
        let brandName = locStorage[property].brandName
        count += 1

        d3.select(`#model`)
            .transition()
            .duration(300)
            .attr("opacity", 0)
            .remove()

        d3.select(`#${brandName}`)
            .transition()
            .duration(300)
            .attr("opacity", 0)
            .remove()
            .end()
            .then(() => {
                if (count === _.size(locStorage)) {
                    count += 1 // reload only once
                    this.drawContent(this.dataset)
                    if (zoomScale > 1) {
                        this.drawBrush(zoomScale)
                    }
                }
            })
    }
}

export default drawContent
